import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './formItemMessage.css';

/*
#tailwind
formatItemMessage formatItemMessage--default formatItemMessage--error
*/

function FormItemMessage({ context, message, ...other }) {
  return (
    <div
      {...other}
      className={bem`formItemMessage--${{
        [context]: true,
      }}`}
    >
      {message}
    </div>
  );
}

FormItemMessage.propTypes = {
  message: PropTypes.string,
  context: PropTypes.oneOf(['error', 'default']),
};

FormItemMessage.defaultProps = {
  message: undefined,
  context: 'default',
};

export default FormItemMessage;
